function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M42.5 14.2v269.3h198.4V14.2H42.5zm170.1 28.3v21.3H70.9V42.5h141.7zM70.9 113.4V92.1h141.7v21.3H70.9zm141.7 28.3V163H70.9v-21.3h141.7zM70.9 255.1v-63.8h141.7v63.8H70.9z"
})));